import * as React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
const ControlCascader = React.memo((props) => (<Icon component={() => (<svg focusable="false" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
        <path d="M5.946 3.446a.5.5 0 0 1 .638-.057l.07.057 4.2 4.2a.5.5 0 0 1 .057.638l-.057.07-4.2 4.2a.5.5 0 0 1-.765-.638l.057-.07L9.793 8 5.946 4.154a.5.5 0 0 1-.057-.638l.057-.07Z"/>
      </svg>)} {...props}/>));
export default ControlCascader;
